import * as React from "react";
import { Box, Button, Tooltip, useColorModeValue } from "@chakra-ui/react";
import { color, variant } from "theme/names";

export const DateButton = React.forwardRef<any, any>((props, ref) => {
  // @ts-ignore
  const { content, tooltipText = "", isActive = false, ...rest } = props;
  // const backgroundColor = useColorModeValue(isActive ? "primary.lightMode.100" : "white", isActive ? "primary.darkMode.100" : "#1E1E1E")
  return (
    <Tooltip label={tooltipText}>
      <Button
        variant={props.isActive? variant.Button.lightSelected : variant.Button.light}
        height="40px"
        lineHeight="1.2"
        transition="all 0.2s cubic-bezier(.08,.52,.52,1)"
        px="4"
        fontSize="12px"
        // fontWeight="500"
        // backgroundColor={backgroundColor}
        // borderColor={useColorModeValue(
        //   "border.lightMode.light",
        //   "border.darkMode.light"
        // )}
        // color={useColorModeValue(
        //   isActive ? color.primary.lightMode.default : "text.lightMode.light",
        //   isActive ? "white" : "text.darkMode.light"
        // )}
        // _hover={{
        //   bg: useColorModeValue(
        //     "primary.lightMode.100",
        //     "primary.darkMode.100"
        //   ),
        //   color: color["text.lightMode.standard"],
        // }}
        // _active={{
        //   bg: useColorModeValue(
        //     "primary.lightMode.200",
        //     "primary.darkMode.200"
        //   ),
        //   color: "white",
        // }}
        // @ts-ignore
        ref={ref}
        // @ts-ignore
        {...rest}
      >
        {content}
      </Button>
    </Tooltip>
  );
});
